// extracted by mini-css-extract-plugin
module.exports = {"ReadMore":"_1vW4roOJEy4U4XmAz5e6Jt","text":"_27bvz4BeMb7-EZYCYgLFpd","desc":"cZM1Wza0gBc8aEx01gYQS","hidden":"FOHJU7ZLftCojNMXwERLS"};